<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div>
        <el-button type="text" @click="$router.push('/platform')"
          >人才币规则</el-button
        >
        <el-button type="text" @click="$router.push('/brokerage')"
          >代理规则</el-button
        >
        <el-button type="text" @click="$router.push('/fee')">会员</el-button>
        <el-button type="text" @click="$router.push('/rules')"
          >就业补贴</el-button
        >
        <el-button type="primary">企业邀请规则</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <div class="section shadow" style="padding: 10px 50px">
        <template>
          <p class="flex fdfsdf">
            企业邀请企业入驻奖励规则：
            <el-switch
              v-model="form.data.company_invite_open_status"
              active-text="启用活动"
              inactive-text="关闭活动"
              :active-value="1"
              :inactive-value="2"
              @change="handleSwitchChange"
            >
            </el-switch>
          </p>
          <p>
            1、认证成功的企业的账号可参与邀请其他企业入驻，若被邀请企业招聘成功，则邀请人可获得现金奖励
          </p>
          <p>
            2、邀请企业新账号注册成功后，绑定双方邀请关系，邀请人企业账号未删除情况下，所邀请的企业招聘成功的每个员工都可以获得对应奖励
          </p>
          <p>3、发放邀请奖励时间以被邀请企业成功扣取服务费时间为准</p>
          <p>4、若修改了奖励金额，则后续发放的奖励以新修改的金额为准</p>
          <p>
            5、若活动被关闭，则新注册的企业账号将不再展示活动入口，邀请成功的账号也将不再发放奖励
          </p>
        </template>
        <el-form
          ref="elFormDom"
          label-width="80px"
          label-position="right"
          :model="form.data"
          :rules="form.rules"
        >
          <el-row :gutter="40">
            <el-col :span="8">
              <el-form-item prop="company_invite_amount" label="奖励金额">
                <el-input
                  type="age"
                  v-model="form.data.company_invite_amount"
                  placeholder="请输入奖励金额"
                >
                  <span slot="suffix">元</span>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="section shadow" style="padding: 20px; margin-top: 40px">
        <el-row type="flex" justify="center">
          <el-button @click="reset">重置</el-button>
          <el-button
            type="primary"
            :loading="form.loading"
            :disabled="form.loading"
            @click="confirm"
            >确定</el-button
          >
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
export default {
  name: "AgentList",
  components: {
    VTable,
  },
  data() {
    return {
      form: {
        loading: false,
        data: {
          company_invite_open_status: "1",
          company_invite_amount: "300",
        },
        rules: {
          company_invite_amount: [
            { required: true, message: "奖励金额不能为空" },
            // { type: "number", message: "佣金比例只能输入整数" },
          ],
        },
      },
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    getTable() {
      this.$http.get("admin/rule/getInvite", { params: {} }).then((res) => {
        if (res.code === 1) {
          this.form.data = res.data;
          this.form.data.company_invite_open_status = Number(
            res.data.company_invite_open_status
          );
          this.form.data.company_invite_amount = Number(
            res.data.company_invite_amount
          );
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSwitchChange() {
      this.$http
        .post("admin/rule/setInvite", {
          open_status: this.form.data.company_invite_open_status,
        })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("设置成功");
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.form.loading = false;
        });
    },
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          this.$http
            .post("admin/rule/editInvite", {
              amount: this.form.data.company_invite_amount,
            })
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("设置成功");
              } else {
                this.$message.error(res.msg);
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
    reset() {
      this.$refs.elFormDom.resetFields();
    },
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
.fdfsdf {
  justify-content: space-between;
  align-items: center;
}
</style>